<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Bank Payments</h1>
    <p>As part of your payroll setup, we can help take the hassle out of making payments — whether that’s paying employees or sending amounts to HMRC.</p>
    <p>We're a BACS-approved bureau, which means we can securely process these payments on your behalf, directly from your business bank account. </p>
    <p>Alternatively, if you prefer to stay hands-on, we can generate a BACS payment file for you to upload to your Internet Banking yourself.</p>
    <p>And of course, if you don’t need us to handle payments at all, that’s fine too.</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value="BACS" v-model="formData.banking.bankingExportType">I would like Qtac to submit BACS payments on our behalf<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value="InternetBanking" v-model="formData.banking.bankingExportType">I require a Internet Banking file to be provided to allow me to process the payment<span class="radiomark"></span></label>
                        <label class="radio-label custom-check"><input type="radio" value="None" v-model="formData.banking.bankingExportType">We'll take care of our payments<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, watch } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object
})


const validateStep = () => {
  if (props.formData.banking.bankingExportType === undefined || props.formData.banking.bankingExportType === null || props.formData.banking.bankingExportType === '') {
    error.value = 'Please select an option.';
    return false;
  }
  error.value = null;
  return true;
}




const executeStep = async () => {

  if(props.formData.banking.bankingExportType != 'None') props.formData.banking.isRequired = true;

  return true;
}




defineExpose({ validateStep, executeStep });

</script>